import { callDelete, get, post, put } from "@/services/api.services";
import { SavedObject } from "../commonModels";
import { SavedSchemaConfigSummary } from "@/services/schemas/manageSchemasAPI";
import { SavedExperimentMethod } from "@/services/experimentMethods/experimentMethodsAPI";
import { PlatformDTO } from "@/services/commonModels";
import { ExperimentMetadataDTO, SavedExperimentMetadata } from "@/lib/experimentMetadata";
import { RegistryEntry } from "@/services/registries/registriesAPI";

export enum ExperimentObjective {
    NONE = "None",
}

export type UnsavedExperimentGroup = {
    name: string;
    schemaConfigId: string;
    objective: ExperimentObjective | null;
    experimentMethodId: string | null;
    isAvailableInExperimentSetup: boolean;
    isFermenterRunExperimentGroup: boolean;
    isConfluenceExperimentSetupRequired: boolean;
    experimentMetadata?: ExperimentMetadataDTO | null;
    platformId: string | null;
    elnFolderId: string | null;
    lookerExploreGroupId: string | null;
};

export type SavedExperimentGroup = UnsavedExperimentGroup &
    SavedObject<string> & {
        code: string;
        objective: ExperimentObjective | null;
    };

export type ExperimentGroupDTO = SavedExperimentGroup & {
    schemaConfig: SavedSchemaConfigSummary;
    experimentMethod: SavedExperimentMethod | null;
    experimentMetadata: SavedExperimentMetadata | null;
    platform: PlatformDTO | null;
};

export const experimentGroupsAPI = {
    fetchExperimentGroups: async (): Promise<ExperimentGroupDTO[]> => {
        return get(`/experiment/groups`);
    },
    fetchExperimentGroupsWithMetadata: async (): Promise<ExperimentGroupDTO[]> => {
        return get(`/experiment/groupsWithMetadata`);
    },
    fetchExperimentGroupByCode: async (code: string): Promise<ExperimentGroupDTO> => {
        return get(`/experiment/groups/byCode/${code}`);
    },
    fetchExperimentGroup: async (experimentGroupId: string): Promise<ExperimentGroupDTO> => {
        return get(`/experiment/groups/${experimentGroupId}`);
    },
    fetchAllLookerExploreGroupOptions: async (): Promise<RegistryEntry[]> => {
        return get(`/experiment/groups/lookerExploreGroups`);
    },
    createExperimentGroup: async (
        experimentGroup: UnsavedExperimentGroup
    ): Promise<SavedExperimentGroup> => {
        return post("/experiment/groups", experimentGroup);
    },
    updateExperimentGroup: async (
        experimentGroup: Omit<SavedExperimentGroup, "createdAt" | "updatedAt">
    ): Promise<SavedExperimentGroup> => {
        return put(`/experiment/groups/${experimentGroup.id}`, experimentGroup);
    },
    deleteExperimentGroup: async (experimentGroupId: string) => {
        return callDelete(`/experiment/groups/${experimentGroupId}`);
    },
};
